import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    innerHTML: _ctx.markdown.render(_ctx.content),
    style: {"width":"100%"}
  }, null, 8, _hoisted_1))
}